import { useEffect } from "react";
import { useConfigLayout } from "../../../../hooks/useConfigLayout"
import UtilityPageLayout from "../../component/layout/UtilityPageLayout"
import { AuditLogList } from "./AuditLogList";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";

export const AdminUtilAuditLogPage = () =>{
    const { updateLayout } = useConfigLayout();
    useEffect(()=>{
        updateLayout({
            showBreadCrumb: false,
        })
    },[])
    return (<UtilityPageLayout title="Audit Log" feature={FeatureFlagName.ADMIN_AUDIT_LOG}>
        <AuditLogList />
    </UtilityPageLayout>)
}